import { render, staticRenderFns } from "./GetReinvent.vue?vue&type=template&id=4a2a9fb2&scoped=true&"
import script from "./GetReinvent.vue?vue&type=script&lang=js&"
export * from "./GetReinvent.vue?vue&type=script&lang=js&"
import style0 from "./GetReinvent.vue?vue&type=style&index=0&id=4a2a9fb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2a9fb2",
  null
  
)

export default component.exports